import { render, staticRenderFns } from "./receivers.vue?vue&type=template&id=80c6ec4a&scoped=true&"
import script from "./receivers.vue?vue&type=script&lang=js&"
export * from "./receivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c6ec4a",
  null
  
)

export default component.exports